// @flow

import React from 'react';
import styled from 'styled-components';

import {ViewModeTitle} from 'app/general/detailpage/ViewModeTitle';
import {gt} from 'app/utils/i18n';
import type {AnyStepType} from 'app/steps/types';
import {type ApplyDocumentShaperFuncType} from 'app/steps/document-shaper';

import {LoadableBaseDiagram} from './BaseDiagram';
import {makeDiagramEditable} from './make-editable';

import {
  diagramFullscreenLayoutOptions,
  diagramFullscreenPaperOptions,
} from 'app/procedures/components/ProcedureDiagram/ProcedureDiagramSidebar';

export const StyledContainerDiv = styled.div.attrs({
  className: 'd-flex',
})`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  > div > .diagram-canvas .btn-toolbar {
    position: absolute;
    left: 10px;
    top: 10px;

    .btn {
      font-size: 70%;
    }
  }
`;

type Props = {
  elements?: 'view' | 'edit',
  onStepClick?: (string) => void,
  onApplyDocumentShaper?: ApplyDocumentShaperFuncType,
  toggleDiagram: () => void,
  steps: Array<AnyStepType>,
};

export const ProcedureDiagramMobile = ({
  steps,
  toggleDiagram,
  elements = 'view',
  onStepClick,
  onApplyDocumentShaper,
}: Props) => (
  <StyledContainerDiv>
    <LoadableBaseDiagram
      elements={elements}
      onStepClick={onStepClick}
      onApplyDocumentShaper={onApplyDocumentShaper}
      layoutOptions={diagramFullscreenLayoutOptions}
      paperOptions={diagramFullscreenPaperOptions}
      toggleDiagram={toggleDiagram}
      steps={steps}
    >
      {(diagram, zoomControl) => (
        <div className="d-flex flex-column flex-grow-1">
          <ViewModeTitle
            className="bg-white"
            title={gt('Overview')}
            actionsBox={
              <div className="d-flex">
                <button
                  onClick={toggleDiagram}
                  className="btn btn-sm btn-link ml-2"
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            }
          />
          <div className="diagram-canvas flex-grow-1 position-relative">
            {zoomControl}
            {diagram}
          </div>
        </div>
      )}
    </LoadableBaseDiagram>
  </StyledContainerDiv>
);

export const EditableProcedureDiagramMobile = makeDiagramEditable(
  ProcedureDiagramMobile
);
